module.exports = __webpack_public_path__ + "img/colegio.456862b3.jpg";